import {
    VISIBLE_QUESTIONS_RESET,
    VISIBLE_QUESTIONS_UPDATED,
    RESET_BANKER_QUESTIONNAIRE,
    SET_NON_SENSITIVE_USER_DETAILS,
    REVIEW_BANKER_QUESTIONNAIRE,
    RESET_REVIEW_QUESTIONS,
    NAVIGATE_TO_FIRST_QUESTION,
    RESET_NAVIGATE_TO_FIRST_QUESTION,
    UPDATE_UNSAVED_ANSWERS_ON_SAVE,
    CLEAR_UNSAVED_ANSWERS_ON_DISCARD,
} from '../../constants';

export const updateUnsavedAnswersOnSave = () => ({
    type: UPDATE_UNSAVED_ANSWERS_ON_SAVE,
});
export const clearUnsavedAnswersOnDiscard = () => ({
    type: CLEAR_UNSAVED_ANSWERS_ON_DISCARD,
});

export const resetVisibleQuestions = () => ({
    type: VISIBLE_QUESTIONS_RESET,
});
export const reviewSelection = (visibleQuestions) => ({
    type: REVIEW_BANKER_QUESTIONNAIRE,
    payload: visibleQuestions,
});
export const resetReviewQuestions = () => ({
    type: RESET_REVIEW_QUESTIONS,
});
export const resetSelection = () => ({
    type: RESET_BANKER_QUESTIONNAIRE,
    isRelNameRequired: true,
});

export const updateVisibleQuestions = (visibleQuestonsArray) => ({
    type: VISIBLE_QUESTIONS_UPDATED,
    action: visibleQuestonsArray,
});

export const setNonSensitiveUserdetails = (userData) => {
    const {
        given_name: givenName = '',
        family_name: familyName = '',
        name: userId = '',
        email = '',
    } = userData;
    return {
        type: SET_NON_SENSITIVE_USER_DETAILS,
        payload: {
            givenName,
            familyName,
            email,
            userId,
        },
    };
};

export const navigationToFirstQuestion = () => ({
    type: NAVIGATE_TO_FIRST_QUESTION,
});
export const resetNavigationToFirstQuestion = () => ({
    type: RESET_NAVIGATE_TO_FIRST_QUESTION,
});
